import { Button } from "@twilio-paste/button";
import { ArrowBackIcon } from "@twilio-paste/icons/esm/ArrowBackIcon";
import { ModalFooter, ModalFooterActions } from "@twilio-paste/modal";
import React from "react";

interface AddParticipantFooterProps {
  actionName: string;
  onBack: () => void;
  action: () => void;
  isSaveDisabled?: boolean;
}

const AddParticipantFooter: React.FC<AddParticipantFooterProps> = (
  props: AddParticipantFooterProps
) => {
  return (
    <>
      <ModalFooter>
        <ModalFooterActions justify="start">
          <Button
            variant="secondary"
            onClick={() => {
              props.onBack();
            }}
          >
            <ArrowBackIcon
              decorative={true}
              title="Voltar para o gerenciamento de conversas"
              size="sizeIcon10"
            />
            Voltar
          </Button>
        </ModalFooterActions>
        <ModalFooterActions>
          <Button
            disabled={props.isSaveDisabled ?? false}
            variant="primary"
            onClick={() => {
              props.action();
            }}
          >
            {props.actionName}
          </Button>
        </ModalFooterActions>
      </ModalFooter>
    </>
  );
};

export default AddParticipantFooter;
